// extracted by mini-css-extract-plugin
export default {"text":"Left_text__qLrhx","date":"Left_date__G2s8p","webinar":"Left_webinar__gvf94"};